<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<div class="textbox">
<p class="center"><em>To Maria, Ariana</em><br/><em>and Alec Bliss-Pryor</em><br/><em>from their loving</em><br/><em>Aunt Carolly</em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312316433_epub_ded_r1.vue?569157eb